import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { from, Subject } from 'rxjs';
import { LoaderComponent } from '../../servicios/loader/loader.component';
import { SeleccionService } from '../../servicios/seleccion.service';
import { ToolsService } from '../../recursos/tools.service';
import { IngresoService } from '../../servicios/ingreso.service';
import { AlertifyService } from 'src/app/recursos/alertify.service';

@Component({
  selector: 'app-permiso-crear-admin',
  templateUrl: './permiso-crear-admin.component.html',
  styleUrls: ['./permiso-crear-admin.component.css']
})
export class PermisoCrearAdminComponent implements OnInit {

  public mr: NgbModalRef;
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<any>;
  public vecPermiso = []; public vecAddPermiso = []; public tituloModal: string; private accion: number;

  constructor(private cargando: LoaderComponent, private srvSelect: SeleccionService, private tools: ToolsService,
    private modalService: NgbModal, private srvInsert: IngresoService, private alerti: AlertifyService) { }

  ngOnInit() {
    this.dtOptions[0] = this.tools.OpcionesTabla(10);
    this.dtTrigger = new Subject();
    this.cargarPermisos();
  }

  //FUNCION QUE CARGA TODOS LOS PERMISOS REGISTRADOS EN EL SISTEMA
  async cargarPermisos() {
    this.vecPermiso = [];
    this.cargando.abrir();
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionPermisos(1, "na", "na", "na").subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      for (let i in res.permiso) {
        this.vecPermiso.push({
          codigo: res.permiso[i]['intIdOpcion'], nombre: res.permiso[i]['strNombre'], describe: res.permiso[i]['strDescripcion'],
          url: res.permiso[i]['strUrl'], metodo: res.permiso[i]['strMetodo'], estado: res.permiso[i]['intEstado'] == 1 ? "Activo" : "Inactivo",
          icono: res.permiso[i]['strIcono']
        });
      }
    }
    this.dtTrigger.next();
    this.cargando.cerrar();
  }
  //FUNCION QUE ABRE EL MODAL PARA AGREGAR UN NUEVO PERMISO
  async modalNuevoPermiso(nameMod) {
    this.tituloModal = "Agregar un permiso nuevo al sistema"; this.accion = 1;
    this.borrarDatos();
    this.mr = this.modalService.open(nameMod);
  }
  //FUNCION QUE PERMITE INGRESAR O EDITAR LOS PERMISOS DEL SISTEMA
  agregarPermiso() {
    this.srvInsert.ingresoGestionPermisos(this.vecAddPermiso[0]['codigo'], this.vecAddPermiso[0]['nombre'], this.vecAddPermiso[0]['describe'],
      this.vecAddPermiso[0]['url'], this.vecAddPermiso[0]['metodo'], this.vecAddPermiso[0]['estado'], this.vecAddPermiso[0]['icono'],
      'na', 'na', 'na', this.accion).subscribe(res => {
        if (res.permiso) {
          this.alerti.success('La actividad ha sido agregado con éxito');
          this.cerrarModal();
          this.reiniciarTabla();
          this.cargarPermisos();
        }
        else
          this.alerti.error("No se puede agregar la actividad");
      });
  }
  //FUNCION PARA ABRIR EL MODAL QUE PERMITE EDITAR UN PERMISO SELECCIONADO
  modalVerPermiso(nameMod, objRol) {
    this.tituloModal = "Editar información del permiso"; this.accion = 4;
    this.buscarPermiso(objRol);
    this.mr = this.modalService.open(nameMod);
  }
  //FUNCION QUE BUSCA UN ROL REGISTRADO EN EL SISTEMA DADO EL CODIGO
  async buscarPermiso(buscar) {
    this.cargando.abrir();
    this.vecAddPermiso = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionPermisos(4, buscar, "na", "na").subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      this.vecAddPermiso.push({
        codigo: res.permiso[0]['intIdOpcion'], nombre: res.permiso[0]['strNombre'], describe: res.permiso[0]['strDescripcion'],
        url: res.permiso[0]['strUrl'], metodo: res.permiso[0]['strMetodo'], estado: res.permiso[0]['intEstado'],
        icono: res.permiso[0]['strIcono']
      });
    }
    else
      this.borrarDatos();
    this.cargando.cerrar();
  }
  //FUNCION PARA INSTANCIAR LAS VARIABLES
  borrarDatos() {
    this.vecAddPermiso = [];
    this.vecAddPermiso.push({ codigo: '', nombre: '', describe: '', url: '', metodo: '', estado: 1, icono: '' });
  }
  //FUNCION QUE ACTUALIZA LOS DATOS DE LA TABLA
  reiniciarTabla() {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
    });
  }
  //FUNCION QUE CIERRA EL MODAL
  cerrarModal() {
    this.mr.close();
  }
}
